import { Component } from "react"
import PropTypes from "prop-types"
import SearchFactor from "components/search-factor"
import "./style.scss"

export default class SmartTradeRuleSearch extends Component {
  static propTypes = {
    setSmartTradeRule: PropTypes.func.isRequired,
    allRules: PropTypes.array.isRequired,
    tabOrder: PropTypes.object,
    addNotification: PropTypes.func.isRequired,
    smartLabel: PropTypes.string.isRequired,
  }

  handleOnClick = (item) => {
    const { addNotification, setSmartTradeRule } = this.props
    addNotification("info", null, `"${item.name}" rule added`)
    setSmartTradeRule(item)
  }

  render() {
    const { smartLabel, allRules, tabOrder } = this.props
    return <SearchFactor
      selectItem={this.handleOnClick}
      factorValueLabel={`Smart ${smartLabel} value`}
      multiSelect
      tabOrderOverride={tabOrder}
      factors={allRules}
    />
  }
}
